<h1 mat-dialog-title>{{data.title}}</h1>
<div class="dialog-content">{{data.message}}</div>
<div mat-dialog-actions>
  @if (!data.hideDenyButton) {
    <button mat-button (click)="onDismiss()">{{data.denyButtonLabel || defaultDenyButtonLabel}}</button>
  }
  <button mat-raised-button
          [color]="data.removeConfirm ? 'warn' : 'primary'"
          (click)="onConfirm()">{{data.confirmButtonLabel || defaultConfirmButtonLabel}}</button>
</div>
